/* eslint-disable jsx-a11y/anchor-is-valid,no-script-url */
import * as React from "react";
import { PropertyDetails } from "../../../core/api/models/project";
import { TabNames } from "./props";

export interface CustomProps {
  tabName: TabNames;
  tabChangeHandler: (tabName: TabNames) => void;
  selectedProperties?: PropertyDetails[];
}

const Tabs: React.FunctionComponent<CustomProps> = (props) => {
  const [tabName, setTabName] = React.useState<TabNames>(
    props.tabName || TabNames.Properties
  );
  const setElementActive = (tabValue: TabNames) => {
    setTabName(tabValue);
    props.tabChangeHandler(tabValue);
  };

  React.useEffect(() => {
    setTabName(props.tabName);
  }, [props.tabName]);

  return (
    <ul
      className="nav tab-underline mb-3 border-bottom font-sm font-weight-semibold flex-nowrap text-nowrap overflow-auto px-md-0 px-3 w-100"
      id="activity-tab"
      role="tablist"
    >
      <li className="nav-item pr-4" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-0 py-2  ${
            tabName === TabNames.Properties ? "active" : "text-gray-600"
          }`}
          onClick={(e) => setElementActive(TabNames.Properties)}
        >
          <span className=" py-1 d-inline-flex">Properties</span>
        </a>
      </li>
      <li className="nav-item pr-4" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-0 py-2  ${
            tabName === TabNames.SelectedProperties ? "active" : "text-gray-600"
          }`}
          onClick={(e) => setElementActive(TabNames.SelectedProperties)}
        >
          <span className=" py-1 d-inline-flex">
            Selected Properties ({props.selectedProperties?.length || 0})
          </span>
        </a>
      </li>
    </ul>
  );
};

export default Tabs;
